<template>
    <div id="app" class="is-clipped lb-full-height">
        <div class="modal blockall" :class="{'is-active':bellowLimit}">
            <div class="modal-background"></div>
            <div class="modal-content">
                
                <div class="card">
                    <div class="card-content">
                        <div class="content">
                            {{$t('window_too_small')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<vue-progress-bar />-->
        <transition :name="transitionName" mode="out-in">
            <component :is="layout">
                <router-view @show-cookies="showCookies" @checkPlan="checkUserPlan"></router-view>
                <app-modal-login v-if="showLoginForm" />
                <!--/transition-->
            </component>
        </transition>
        <div class="copyright-section">
            <div class="legal-links secondary-font is-inline-block" v-html="$t('copyright_text')" />
            <div class="is-inline-block cookies secondary-font">
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a @click="showCookies">{{$t('modify_cookies')}}</a>
            </div>
        </div>
        <p
            style="position: fixed; bottom: 2px; right: 10px; opacity: 0.5"
            class="tag is-primary is-light"
        >
            {{ versionHash }}
        </p>

        <cookies-consent
            :preferencesLabel="$t('cookie_law_preferences')"
            :accept-all-label="$t('cookie_law_accept_all')"
            :revoke-all-label="$t('cookie_law_revoke_all')"
            :preferences="preferences"
            :headerTitle="$t('cookie_law_text')"
            :headerDescription="
                $t('can_read_privacy_policy')
            "
            class="cookie-consent"
            :class="$i18n.locale"
            :openModal="openCookies"
            @on-save-cookie-preferences="changeCookiesSettings"
            @on-accept-all-cookies="changeCookiesSettings"
            @close-cookies-modal="openCookies=false"
            @selectAllChoices="selectAllCookies"
            @revokeAllChoices="revokeAllCookies"
        />
    </div>
</template>

<script>
import { logout } from '@/services/API';
import Default from '@/layouts/Default';
import Project from '@/layouts/Project';
import AppModalLogin from '@/components/AppModalLogin';
import { version } from '../package.json';
import EmbedView from '@/layouts/EmbedView';
import Share from '@/layouts/Share';
import { bootstrap } from 'vue-gtag'
import CookiesConsent from '@/components/CookiesConsent';
import { faTruckMedical } from '@fortawesome/free-solid-svg-icons';
export default {
    components: {
        Default,
        Project,
        AppModalLogin,
        EmbedView,
        Share,
        CookiesConsent,
    },
    data() {
        return {
            transitionName: '',
            allCookies: false,
            performanceCookies: false,
            bellowLimit: false,
            openCookies: false,
            eventSource: undefined,
        };
    },
    computed: {
        preferences(){
            return [
                /*{
                    title: 'Manage preferences',
                    description: 'When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.',

                },*/
                {
                    title: this.$t('cookies_basic_title'),
                    description: this.$t('cookies_basic_text'),
                    items: [
                        {
                            label: '',
                            value: 'basics',
                            isEnable: true,
                            isRequired: true,
                        },
                    ],
                },
                /*{
                    title: this.$t('cookies_functional_title'),
                    description: this.$t('cookies_functional_text'),
                    items: [
                        {
                            label: '',
                            value: 'functional',
                            isEnable: true
                        }
                    ],
                },*/
                {
                    title: this.$t('cookies_performance_title'),
                    description: this.$t('cookies_performance_text'),
                    items: [
                        {
                            label: '',
                            value: 'performance',
                            isEnable: this.isPerformanceEnabled,
                        },
                    ],
                },
            ];
        },
        personalData() {
            return this.$store.getters.personalData;
        },
        showLoginForm() {
            return this.$store.getters.showLoginForm;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        layout() {
            return this.$route.meta.layout || 'Default';
        },
        isDev() {
            return process.env.NODE_ENV !== 'production';
        },
        versionHash() {
            return version + '.' + process.env.VUE_APP_GIT_HASH;
        },
        isPerformanceEnabled(){
            // console.log("checking enabled cookies",this.performanceCookies, this.allCookies)
            return this.performanceCookies || this.allCookies
        },
        isEmbed() {
            if(this.$route.meta){
                if(this.$route.meta.embed){
                    return true;
                }else{
                    return false;
                }
            }
            return false;
        },
        activePlan() {
            return this.$store.getters.activePlan;
        },
        activeProjects() {
            return this.$store.getters.projectsNumber;
        },
        activeObjects() {
            return this.$store.getters.objectsNumber;
        },
        activeUsers() {
            return this.$store.getters.usersNumber;
        },
        planProjectsNumber() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.project.maxNumber
            }
        },
        planObjectsNumber() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.object.maxNumber
            }
        },
        planUsersNumber() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.user ? this.$store.getters.activePlan.configuration.user.maxNumber : 0
            }
            
        },
        projectTypeNumber() {
            return this.$store.getters.personalData.data ? this.$store.getters.personalData.data.projectsPerType : [];
        },
        projectTypeMaxNumber() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration ? this.$store.getters.activePlan.configuration.project.perTypeMaxNumber : 0
            }
            return 0;
        },
        enabledTypes() {
            return this.$store.getters.activePlan.configuration ? this.$store.getters.activePlan.configuration.project.type : []
        }

    },
    watch: {
        $route(to, from) {
            const toDepth = to.path.split('/').length;
            const fromDepth = from.path.split('/').length;
            this.transitionName =
                toDepth < fromDepth ? 'slide-right' : 'slide-left';
        },
        personalData(profile) {
            //this.$ga.set('userId', profile._id);
            if (!profile.name || !profile.name.length) {
                console.warn('[REDIRECT] to profile because name is missing');
                //this.$router.push("profile");
            }
        },
        activePlan(plan) {
            // console.log("ActivePlan changed",plan)
        },
        activeProjects(projectsNumber) {
            // console.log("in project number watcher")
            if (this.planProjectsNumber !== -1) {
                if (this.planProjectsNumber > projectsNumber) {
                    this.$store.commit('PROJECT_CREATION_ENABLED');
                } else {
                    this.$store.commit('PROJECT_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('PROJECT_CREATION_ENABLED');
            }
        },
        activeObjects(objectsNumber) {
            if (this.planObjectsNumber !== -1) {
                if (this.planObjectsNumber > objectsNumber) {
                    this.$store.commit('OBJECT_CREATION_ENABLED');
                } else {
                    this.$store.commit('OBJECT_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('OBJECT_CREATION_ENABLED');
            }
        },
        activeUsers(usersNumber) {
            if (this.planUsersNumber !== -1) {
                if (this.planUsersNumber > usersNumber) {
                    this.$store.commit('USER_CREATION_ENABLED');
                } else {
                    this.$store.commit('USER_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('USER_CREATION_ENABLED');
            }
        }

    },
    created() {
        window.addEventListener('resize', this.onResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize);
    },
    mounted() {
        if (this.isLoggedIn) {
            this.$store.dispatch('fetchProfile').then(() => {
                const url = new URL(process.env.VUE_APP_MERCURE_URL);
                // console.log("profile data", this.$store.getters.user)
                if (this.$store.getters.hasSchool) {
                    // console.log("setting entity id")
                    url.searchParams.append(
                        'topic',
                        'http://plan.' + this.$store.getters.school._id
                    );
                    // console.log("creating eventsource for " + 'http://plan.' + this.$store.getters.user._id)
                    this.eventSource = new EventSource(url);
                    this.eventSource.onmessage = this.onChangeReceived;

                }else if (this.$store.getters.user._id) {
                    // console.log("setting user id")
                    url.searchParams.append(
                        'topic',
                        'http://plan.' + this.$store.getters.user._id
                    );
                    // console.log("creating eventsource for " + 'http://plan.' + this.$store.getters.user._id)
                    this.eventSource = new EventSource(url);
                    this.eventSource.onmessage = this.onChangeReceived;
                }
                this.checkUserPlan();
                
            });
            
        }
        this.$cookies.keys().forEach((f) => {
            if(f.indexOf("_ga")!=-1){
                this.performanceCookies=true;
            }
        });

        

        // console.log(this.bellowLimit)
    },
    methods: {
        logout() {
            this.$router.push('/');
            logout();
        },
        changeCookiesSettings(e) {
            // console.log("change cookies settings",e);
            this.openCookies= false;
            if(e.indexOf('performance')!=-1 || e.indexOf('all')!=-1){
                this.performanceCookies = true;
                // console.log("activating anañytics")
                bootstrap().then((gtag) => {
                    // console.log("analytics activated")
                })
            }else{
                this.performanceCookies = false;
                this.$cookies.keys().forEach((f) => {
                    if(f.indexOf("_ga")!=-1){
                        this.removeCookie(f)
                    }
                });
            }
        },
        removeCookie(cookie){
            // console.log("removing cookie",cookie)
            this.$cookies.remove(cookie)
        },
        onResize(e) {
            if(this.$route.name!="project-view"){
                if(e.target.innerWidth<1124){
                    //console.log(this.$route,this.$route.meta)
                    if(this.isEmbed){
                        this.bellowLimit=false;
                    }else{
                        this.bellowLimit=true;
                    }
                    
                }else{
                    this.bellowLimit=false;
                }
            }else{
                this.bellowLimit=false;
            }
        },
        showCookies(){
            // console.log("TRY TO SHOW COOKIES",this.allCookies,this.performanceCookies)
            //this.$cookies.remove("cookies-accepted")
            //location.reload();
            this.openCookies= true;
        },
        selectAllCookies(){
            this.allCookies=true;
        },
        revokeAllCookies(){
            this.allCookies=false;
            this.performanceCookies=false;
        },
        onChangeReceived(e) {
            const data = JSON.parse(e.data);
            switch (data.type) {
                case 'NEW_PROJECT':
                    // console.log("EVENT RECIVED",data)
                    this.$store.commit('INCREMENT_PROJECTS_NUMBER');
                    this.$store.commit('INCREMENT_PROJECTS_PER_TYPE_NUMBER', { format: data.object.format });
                    // console.log("projects per type",this.$store.getters.projectsPerTypeNumber)
                    break;
                case 'REMOVED_PROJECT':
                    // console.log("EVENT RECIVED",data)
                    this.$store.commit('DECREMENT_PROJECTS_NUMBER');
                    this.$store.commit('DECREMENT_PROJECTS_PER_TYPE_NUMBER', {format:data.object.format});
                    break;
                case 'NEW_OBJECT':
                    this.$store.commit('INCREMENT_OBJECTS_NUMBER');
                    break;
                case 'REMOVED_OBJECT':
                    // console.log("EVENT RECIVED",data)
                    this.$store.commit('DECREMENT_OBJECTS_NUMBER');
                    break;
                case 'NEW_USER':
                    this.$store.commit('INCREMENT_USERS_NUMBER');
                    break;
                case 'REMOVED_USER':
                    this.$store.commit('DECREMENT_USERS_NUMBER');
                    break;

                default:
                    console.log('unhandled event ', data.type || data.message);
            }
        },
        checkUserPlan() {
            /*console.log("checking user plan",this.planProjectsNumber,this.activeProjects,
                this.planProjectsNumber <= this.activeProjects,
            
            )*/
            // console.log(this.projectTypeNumber,Object.keys(this.projectTypeNumber).length)

            if (this.projectTypeMaxNumber != -1) {
                // console.log("checking project creation")
                let canCreateMoreProjects = false;
                //this.enabledTypes.indexOf(this.content.format) === -1 || (this.projectTypeMaxNumber <= this.projectTypeNumber[this.content.format] && this.projectTypeMaxNumber != -1)
                
                for (let element in this.projectTypeNumber) {
                    // console.log(element, this.projectTypeNumber[element])
                    // console.log("can create ", element, this.enabledTypes.indexOf(element) !== -1 && this.projectTypeMaxNumber > this.projectTypeNumber[element]);
                    if (this.enabledTypes.indexOf(element) !== -1 && this.projectTypeMaxNumber > this.projectTypeNumber[element]) {

                        canCreateMoreProjects = true;
                    }
                }
                /*for (let i = 0; i < Object.keys(this.projectTypeNumber).length; i++){
                    console.log(this.projectTypeNumber[i])
                }*/

                //return canCreateMoreProjects
                if (canCreateMoreProjects) {
                    // console.log("commit true")
                    this.$store.commit('PROJECT_CREATION_ENABLED');
                } else {
                    // console.log("commit false")
                    this.$store.commit('PROJECT_CREATION_DISABLED');
                }
            } else if (this.planProjectsNumber !== -1) {
                // console.log("checking global projects number")
                if (this.planProjectsNumber > this.activeProjects) {
                    this.$store.commit('PROJECT_CREATION_ENABLED');
                } else {
                    this.$store.commit('PROJECT_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('PROJECT_CREATION_ENABLED');
            }
            if (this.planObjectsNumber !== -1) {
                if (this.planObjectsNumber > this.activeObjects) {
                    this.$store.commit('OBJECT_CREATION_ENABLED');
                } else {
                    this.$store.commit('OBJECT_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('OBJECT_CREATION_ENABLED');
            }
            if (this.planUsersNumber !== -1) {
                if (this.planUsersNumber > this.activeUsers) {
                    this.$store.commit('USER_CREATION_ENABLED');
                } else {
                    this.$store.commit('USER_CREATION_DISABLED');
                }
            } else {
                this.$store.commit('USER_CREATION_ENABLED');
            }

        },
    },
};
</script>

<style>
html,
body {
    height: 100%;
    overflow: hidden;
}
@import '~animate.css';
@import '~vue-toastification/dist/index.css';

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-30px, 0);
    transform: translate(-30px, 0);
}

.lb-project-card {
    transition: all 0.3s;
}

.lb-project-list {
    opacity: 0;
    /*transform: scale(2);*/
}
.navbar-item img {
    max-height: unset !important;
}
.Vue-Toastification__container {
    z-index: 9999999;
}
</style>

<style lang="scss">
@import './assets/css/fonts.css';
@import './assets/css/colors.css';
@import './style/tailwind.css';
@import 'src/assets/sass/labygram-style';
@import '~vue-plyr/dist/vue-plyr.css';
@import '~bulma-tooltip';
@import '~@creativebulma/bulma-badge';
@import '~@creativebulma/bulma-collapsible';
@import '~bulma-steps-component/bulma-steps.sass';

#app {
    font-family: 'paytone_oneregular';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    height: 100%;
    overflow-y: auto;
}
.pac-container {
    // google maps autocomplete
    z-index: 9999999 !important;
}
.pac-card {
    // google maps autocomplete
    z-index: 9999999 !important;
}

.plyr__video-wrapper {
    height: unset;
}
</style>

<style>
.plyr--youtube.plyr--paused.plyr__poster-enabled:not(.plyr--stopped)
    > .plyr__video-wrapper
    > .plyr__poster {
    display: none;
}
</style>

<style scoped>
.blockall .modal-background {
    background-color: rgba(0, 0, 0, 0.95);
}

.blockall .card {
    max-width: 50%;
    margin: 0 auto;
}

.blockall .card-content,
.blockall .card {
    border-radius: 0;
}

.blockall .card-content {
    background-image: url('./assets/icons/alert.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: auto 101%;
    padding-left: 4rem;

}

.blockall .card-content .content {
    font-family: var(--secondary-font);
    font-size: 1rem;
    line-height: 1.4rem;
    margin: 1rem;
    color: #000000;
}
.tag:not(body).is-primary.is-light{
    color: white !important;
    background-color: transparent;
}

.copyright-section{
    background-color: var(--eduloc-red);
    position: fixed;
    bottom: 0;
    width: 100%;
}
.copyright-section .legal-links{
    font-size: 0.9rem;
    padding-top: 5px;
    padding-bottom: 3px;
    padding-left: 20px;
    color: white;
}
.copyright-section .legal-links /deep/ a, .copyright-section .cookies a{
    color: white;
}
.copyright-section .legal-links /deep/ a:hover, .copyright-section .cookies a:hover{
    color: white;
    text-decoration: underline;
}
.copyright-section .cookies{
    font-size: 0.9rem;
    padding-top: 5px;
    padding-bottom: 3px;
    padding-left: 0.3rem;
    color: white;
}
</style>
